// extracted by mini-css-extract-plugin
export var alignCenter = "_9i-d";
export var bannerShown = "_9i-6";
export var buttonContent = "_9i-0";
export var cardList = "_9i-1";
export var centerContent = "_9i-2";
export var chevron = "_9i-3";
export var closePanelButton = "_9i-k";
export var conversationContextContainer = "_9i-l";
export var conversationDetailContainer = "_9i-4";
export var detailWrapper = "_9i-7";
export var dropdownButton = "_9i-e";
export var dropdownTitle = "_9i-9";
export var fullHeight = "_9i-5";
export var hidden = "_9i-a";
export var icon = "_9i-b";
export var mergeSuggestionWrapper = "_9i-m";
export var panel = "_9i-i";
export var portalButtonsWrapper = "_9i-c";
export var right = "_9i-j";
export var tableSummaryContainer = "_9i-8";
export var tableSummaryHeader = "_9i-g";
export var threeDotsButton = "_9i-f";
export var wide = "_9i-h";